import { ArrowsLeftRight, ArrowUDownLeft } from '@phosphor-icons/react'

export const transactionTypes = {
  exchange: {
    label: 'Cambios',
    icon: ArrowUDownLeft,
  },
  refund: {
    label: 'Devoluciones',
    icon: ArrowsLeftRight,
  },
}
